var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row no-gutters manage-layout"},[_c('div',{staticClass:"col-sm-3 sidebar d-none d-sm-block"},[_c('ManageMenu')],1),_c('div',{staticClass:"col-sm-9 overflow-clip pb-chat"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{key:_vm.fullishPath})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }